import React from "react";
import { useRecommendationStore } from "../../stores/recommendationStore";
import { militaryIcon, birthdayIcon, wholesaleIcon } from "assets";
import { useAuth } from "hooks/useAuth";

// Компонент переключателя цін військових/до Дня Народження
const RecommendationPriceToggle = React.memo(() => {
  // Отримуємо дані та дії зі стору рекомендацій
  const priceViewMode = useRecommendationStore(
    (state) => state.viewSettings.priceViewMode,
  );
  const setPriceViewMode = useRecommendationStore((state) => state.setPriceViewMode);

  const { isAllowed } = useAuth();
  const canViewWholesale = isAllowed("recommendations:view-wholesale");

  const options = [
    { id: "price_05", icon: militaryIcon, title: "Ціни для військових" },
    { id: "price_birthday", icon: birthdayIcon, title: "Ціни до Дня Народження" },
  ];
  if (canViewWholesale) {
    options.push({ id: "price_wholesale", icon: wholesaleIcon, title: "Оптові ціни" });
  }

  return (
    <div className="price-menu-container">
      {options.map((option) => (
        <div
          key={option.id}
          className={`menu-item clickable ${priceViewMode === option.id ? "active" : ""}`}
          onClick={() => setPriceViewMode(option.id)}
          title={option.title}
        >
          <img className="icon" src={option.icon} alt={option.id} />
        </div>
      ))}
    </div>
  );
});

export default RecommendationPriceToggle;
